import React from "react";
import { Clock, AlertTriangle, CheckCircle2 } from "lucide-react";
import { slaInfo, humanDuration } from "@/lib/format";

const LBL = {
  hu: { breached: "SLA lejárt", due: "Hamarosan lejár", left: "hátra", waited: "várt", ok: "határidőn belül" },
  en: { breached: "SLA breached", due: "Due soon", left: "left", waited: "waited", ok: "within SLA" },
  de: { breached: "SLA überschritten", due: "Bald fällig", left: "übrig", waited: "gewartet", ok: "im SLA" },
  fr: { breached: "SLA dépassé", due: "Bientôt dû", left: "restant", waited: "attendu", ok: "dans le SLA" },
};

export function SlaBadge({ createdAt, status, lang = "en", size = "sm", hours, closed }) {
  const s = slaInfo(createdAt, status, hours, closed);
  const t = LBL[lang] || LBL.en;
  const pad = size === "lg" ? "px-2 py-1 text-[12px]" : "px-1.5 py-0.5 text-[10px]";

  let cls, icon, text;
  if (s.resolved) {
    cls = "border-zinc-700 bg-zinc-800/50 text-zinc-400";
    icon = <CheckCircle2 size={11} />;
    text = `${humanDuration(s.mins)} ${t.waited}`;
  } else if (s.overdue) {
    cls = "border-red-500/50 bg-red-500/15 text-red-300";
    icon = <AlertTriangle size={11} />;
    text = `${t.breached} · ${humanDuration(s.remaining)}`;
  } else if (s.dueSoon) {
    cls = "border-amber-500/50 bg-amber-500/15 text-amber-300";
    icon = <Clock size={11} />;
    text = `${t.due} · ${humanDuration(s.remaining)} ${t.left}`;
  } else {
    cls = "border-zinc-700 bg-zinc-800/50 text-zinc-300";
    icon = <Clock size={11} />;
    text = `${humanDuration(s.remaining)} ${t.left}`;
  }

  return (
    <span data-testid="sla-badge" className={`inline-flex items-center gap-1 rounded border font-medium ${pad} ${cls}`}>
      {icon} {text}
    </span>
  );
}
